var _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgConnected = function SvgConnected(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#82BD7B"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13.667A5.667 5.667 0 1 0 8 2.333a5.667 5.667 0 0 0 0 11.334Zm0 1A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334Z"
  }))));
};
export default SvgConnected;